import { AccountingEventType, PURCHASE_ORDER_DOCUMENT_TYPE } from '@received/pricing-model';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { getDocumentIdNameByType } from '../../../../utils/GeneralUtils';
import { CustomerDetails } from '../../../CustomerDetails/CustomerDetails';
import { Button, Icon } from '../../../_uiComponents';
import { contractIdFormat } from '../../../../utils/ContractUtils';
import { BillingDocumentType } from '../../../../types/generalTypes';
import { PurchaseOrderData } from '../../../../pages/Contracts/ContractComponent/PurchaseOrder/PurchaseOrder.types';
import styles from './TopBar.module.scss';

interface TopBarProps {
	document?: BillingDocumentType;
	onClose: () => void;
	onDownload?: () => void;
}

const isPurchaseOrder = (doc?: BillingDocumentType): doc is PurchaseOrderData => {
	return doc?.accountingEventType === PURCHASE_ORDER_DOCUMENT_TYPE;
};

export const TopBar = ({ document, onClose, onDownload }: TopBarProps) => {
	const { t } = useTranslation('translation');

	// Handle Purchase Order vs Billing Document differences
	const customerName = isPurchaseOrder(document) ? document?.buyer?.name : (document as any)?.customer?.name;
	const customerLogo = isPurchaseOrder(document) ? undefined : (document as any)?.customer?.iconData;
	const hasContractId = isPurchaseOrder(document) ? false : !!(document as any)?.contractId;

	const getDocumentTypeLabel = () => {
		if (isPurchaseOrder(document)) {
			return t('purchaseOrder');
		}
		switch (document?.accountingEventType) {
			case AccountingEventType.INVOICE:
				return t('invoice');
			case AccountingEventType.CREDIT:
				return t('creditNote');
			default:
				return t('debitNote');
		}
	};

	return (
		<div className={styles.topToolbar}>
			<div className={styles.leftContainer}>
				<CustomerDetails logo={customerLogo} name={customerName} imgClassName={styles.name} nameStyle={styles.title} />
				<div>
					{hasContractId && (
						<span className={styles.greyTitle}>
							{t('contract')} {contractIdFormat((document as any)?.poNumber, (document as any)?.contractNumber)}
							{' • '}
						</span>
					)}
					<span className={styles.greyTitle}>
						{getDocumentTypeLabel()}{' '}
						{isPurchaseOrder(document) ? contractIdFormat(document?.poNumber, document?.contractNumber) : getDocumentIdNameByType(document)}
					</span>
				</div>
			</div>
			<div className={styles.leftContainer}>
				{onDownload && (
					<Button color='neutral' type='link' className={styles.button} onClick={onDownload}>
						<Icon imgType='downloadArrow' color='white' width={2} />
					</Button>
				)}
				<Button type='outlined' color='neutral' onClick={onClose} className={clsx(styles.close, styles.button)}>
					<Icon imgType='x_icon' color='white' width={1.2} />
				</Button>
			</div>
		</div>
	);
};
